// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"ImageSliderCarousel_Overlay__3LFr4","Content":"ImageSliderCarousel_Content__kLl0y","second_heading":"ImageSliderCarousel_second_heading__2TNyg"};